module.exports = __webpack_public_path__ + "img/acer.79db5a69.png";